<script lang="ts">
  export type BtnThemeToggleProps = Omit<GatButtonProps, 'onClick'> & {
    showTooltip?: boolean
  }
</script>

<script setup lang="ts">
  import { type GatButtonProps } from '@gat-ship/vue-components'
  import { globalUtils } from '@gat-ship/utils'
  import { computed } from 'vue'
  import {
    TooltipProvider,
    Tooltip,
    TooltipContent,
    TooltipTrigger
  } from '@gat-ship/vue-components/tooltip'
  const theme = globalUtils.composables.useTheme()

  const props = withDefaults(defineProps<BtnThemeToggleProps>(), {
    label: 'Toggle Theme',
    size: 'icon'
  })

  const icon = computed(() => {
    if (props.icon) return props.icon
    return 'SunMoon'
  })
</script>
<template>
  <tooltip-provider>
    <tooltip :disabled="!props.showTooltip">
      <tooltip-trigger as-child>
        <gat-button v-bind="props" :icon="icon" @click="theme.toggleTheme()" />
      </tooltip-trigger>
      <tooltip-content>
        <div>Theme</div>
      </tooltip-content>
    </tooltip>
  </tooltip-provider>
</template>
